module.exports = __webpack_public_path__ + "img/1.7e02f9c6.jpg";